import { createSvgIcon } from '@automata/mui-theme';
export const SealIcon = createSvgIcon(
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
    <path d="M57.9912 50.0278L37.9912 50.0278L37.9912 53.0278L57.9912 53.0278V50.0278Z" />
    <path d="M57.9998 53.0189V33.0189L54.9998 33.0189V53.0189H57.9998Z" />
    <path d="M54.2599 51.4089L56.3812 49.2876L36.5822 29.4886L34.4609 31.6099L54.2599 51.4089Z" />
    <path d="M63 54.019H84L62 76.019V55.019C62 54.4668 62.4477 54.019 63 54.019Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M64 56.019V71.1906L79.1716 56.019H64ZM63 54.019C62.4477 54.019 62 54.4668 62 55.019V76.019L84 54.019H63Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 73V23H81V54H84V22C84 20.8954 83.1046 20 82 20H14C12.8954 20 12 20.8954 12 22V74C12 75.1046 12.8954 76 14 76H62V73H15Z"
    />
  </svg>,
  'SealIcon'
);
